export const STRESS_COMMS_TEST_IDS = {
    STRESS_COMMS_WRAPPER: "STRESS_COMMS_WRAPPER",
};
